(function () {
  'use strict';

  angular
    .module('neo.services')
    .factory('Configuracio', Configuracio);

  function Configuracio($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + 'configuracio/tarification', {}, {
      get:    { method: 'GET' },
      update: { method: 'PUT' }
    });
  }
}());
